import { css } from "@emotion/css";
import { Text } from "../../../components";
import Bg from "../assets/podcastBg.png";
import { HeaderBase } from "../styles";
import { PodcastPlayButton } from "./PodcastPlayButton";

const date = new Date();
const isMorning = date.getHours() < 12;
const greeting = isMorning ? "GOOD MORNING" : "GOOD AFTERNOON";
const subtitle = isMorning
  ? "Start your day with your morning podcast"
  : "Catch up on your favorite podcast";

export const HomeHeader = () => {
  return (
    <HeaderBase bg={Bg}>
      <div>
        <Text.Body2XS>{greeting}</Text.Body2XS>
        <Text.H2
          className={css`
            @media (max-width: 768px) {
              display: none;
            }
          `}
        >
          Rise and Shine
        </Text.H2>
        <Text.H6>{subtitle}</Text.H6>
      </div>
      <PodcastPlayButton />
    </HeaderBase>
  );
};
